// extracted by mini-css-extract-plugin
export var clauseRow = "_f0-6";
export var emptyState = "_f0-d";
export var filterContent = "_f0-a";
export var filterGroup = "_f0-1";
export var filterGroupContainer = "_f0-0";
export var nestedGroup = "_f0-2";
export var nestedGroupContent = "_f0-b";
export var nestedGroupDepth1 = "_f0-3";
export var nestedGroupDepth2 = "_f0-4";
export var nestedGroupDepth3 = "_f0-5";
export var nestedGroupEmpty = "_f0-c";
export var operatorAnd = "_f0-8";
export var operatorOr = "_f0-9";
export var operatorToggle = "_f0-7";
export var removeGroupButton = "_f0-e";